<div class="d-flex flex-row justify-content-center mt-3">
    <span class="mx-2">تمت الطباعة بواسطة {{ userName }}</span>
    <span>بتاريخ</span><span class="mx-2">{{ datePart  }}</span>
    <span>وفي ساعة </span><span class="mx-2" dir="ltr">{{ timePart  }}</span>
</div>